export default __webpack_public_path__ + "static/media/apiary_icon.d199d90a.svg";